import { AppLoadingScreen, RouteElement } from '@components'

import React, { ReactElement, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, Route, Routes } from 'react-router'

import { Timeout } from '../../types/timeout'
import { useSignupGuide } from './context/signupGuideContext'
import { CreateOrganization } from './elements/CreateOrganization'
import { CreateUser } from './elements/CreateUser'
import { GuidePath } from './enums/guide-path'

const LOADING_SCREEN_TIMEOUT = 500

export const SignupGuide = (): ReactElement => {
  const { user, routeUmbrellaId, isUserLoading } = useSignupGuide()
  const { t } = useTranslation()

  const [showLoadingScreen, setShowLoadingScreen] = useState(isUserLoading)

  useEffect(() => {
    let timeoutId: Timeout

    if (!isUserLoading) {
      timeoutId = setTimeout(() => {
        setShowLoadingScreen(false)
      }, LOADING_SCREEN_TIMEOUT)
    } else {
      setShowLoadingScreen(true)
    }

    return () => clearTimeout(timeoutId)
  }, [isUserLoading])

  const initialPath = useMemo(() => {
    if (routeUmbrellaId) {
      return `${routeUmbrellaId}/${GuidePath.CreateOrganization}`
    }
    if (isUserLoading) {
      return
    }

    return user ? GuidePath.CreateOrganization : GuidePath.CreateUser
  }, [routeUmbrellaId, user, isUserLoading])

  if (showLoadingScreen) {
    return <AppLoadingScreen text={t('loading')} />
  }

  return (
    <Routes>
      <Route
        path={`/${GuidePath.CreateUser}`}
        element={
          <RouteElement isHashRouter>
            <CreateUser />
          </RouteElement>
        }
      />
      <Route
        path={`/${GuidePath.CreateOrganization}`}
        element={
          <RouteElement isHashRouter>
            <CreateOrganization />
          </RouteElement>
        }
      />
      <Route
        path={`/:umbrellaId/${GuidePath.CreateOrganization}`}
        element={
          <RouteElement isHashRouter>
            <CreateOrganization />
          </RouteElement>
        }
      />
      <Route
        path="*"
        element={
          <RouteElement isHashRouter>{initialPath ? <Navigate to={`/${initialPath}`} replace /> : <></>}</RouteElement>
        }
      />
    </Routes>
  )
}
